import superagent from 'superagent'
import {postBaiduData} from '../assets/js/util'
const baseUrl = 'https://wx.dudubashi.com' // 替换为基本URL
// 公共接口回调处理
export const RequestCommonResponse = (options) => {
  var _code = options.res.result
  if (_code === '0005') {
    options.rootState.common.need_jump_login = true
    setTimeout(function () {
      options.rootState.common.need_jump_login = false
    }, 500)
  } else if (_code === '0000') {
    options.successCallback(options.res || {})
  } else {
    options.failCallback(options.res || {})
  }
}

// 是否有公告信息
export const getNotice = ({ commit, state, rootState }, params) => {
  // 参数
  // position 1:首页，2:班次详情页，3:验票页面
  // line_id: 线路id (2, 3 必传)
  // city_name: 城市名称
  params.enterprise_id = rootState.config.enterprise_id
  params.city_name = rootState.address.current_city || rootState.address.location_city || ''
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/system/notice/get_urgent_message')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 公告信息详情
export const getNoticeDetail = ({ commit, state, rootState }, notice_id) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/system/notice/urgent_message_detail')
    .send({
      notice_id: notice_id
    })
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 班线搜索
export const searchLine = ({commit, state, rootState}, params) => {
  var _params = params.query_params
  _params.with_walk_distance = 1
  _params.enterprise_id = rootState.config.enterprise_id
  _params.city = rootState.address.current_city || rootState.address.location_city
  if (rootState.userInfo.user_id) {
    _params.user_id = rootState.userInfo.user_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/api/search_new')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 搜索相似线路
export const similarLine = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    var _params = params || {}
    _params.enterprise_id = rootState.config.enterprise_id
    _params.user_id = rootState.userInfo.user_id || ''
    _params.city_name = _params.city_name = rootState.address.current_city || rootState.address.location_city
    superagent
    .post(baseUrl + '/index.php/line/suggest/similar_line')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        })
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 提交开通线路
export const organizeLine = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    var _params = params || {}
    _params.enterprise_id = rootState.config.enterprise_id
    _params.user_id = rootState.userInfo.user_id || ''
    _params.city_name = _params.city_name = rootState.address.current_city || rootState.address.location_city
    superagent
    .post(baseUrl + '/index.php/line/suggest/add_line')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 获取未开通线路信息
export const getUnopenLineInfo = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    var _params = {
      user_id: rootState.userInfo.user_id,
      line_id: params.line_id,
      enterprise_id: rootState.config.enterprise_id
    }
    if (params.type !== undefined) {
      _params.type = params.type
    }
    superagent
    .post(baseUrl + '/index.php/line/suggest/line_info')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 获取车辆定位
export const getBusLocation = ({ commit, state, rootState }, line_id) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/info/line_bus_locations')
    .send({
      'line_id': line_id
    })
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        if (res.data && res.data.length) {
          res.data.forEach(element => {
            if (element.gps_time) {
              let date1 = new Date(element.gps_time) // 将时间字符串转换为Date对象
              let date2 = new Date()
              let diff = Math.abs(date2 - date1) // 计算两个时间的差异（以毫秒为单位）
              let diffInSeconds = diff / 1000 // 将差异转换为秒
              element.gps_time_show_line = diffInSeconds
              console.log('diffInSeconds--->', diffInSeconds)
            }
          })
        }
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 关注班线
export const collectBusLine = ({ commit, state, rootState }, line_id) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/info/line_collect')
    .send({
      'line_id': line_id
    })
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            commit('UPDATE_IS_TRIGGER_COLLECT', true)
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

export const sendFeedback = ({ commit, state, rootState }, params) => {
  params.enterprise_id = rootState.config.enterprise_id
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/users/suggest/suggest_report')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

export const sendFeedbackEnt = ({ commit, state, rootState }, params) => {
  params.enterprise_id = rootState.config.enterprise_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/users/suggest/suggest_report_huawei')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取评价配置信息
export const getEvaluateInfo = ({ commit, state, rootState }, line_id) => {
  var _params = {
    line_id: line_id
  }
  if (rootState.config.enterprise_id) {
    _params.enterprise_id = rootState.config.enterprise_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/info/get_evaluate_info')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 发送评价信息
export const sendEvaluateInfo = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/info/evaluate_line')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 获取用户关注线路
export const getUserCollectLineInfo = ({ commit, state, rootState }, params) => {
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/info/get_collect_line')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 获取定制开通列表
export const getUserCustomLineInfo = ({ commit, state, rootState }, params) => {
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/suggest/get_suggest_lines')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}
// 我的消息
export const getMyMessage = ({ commit, state, rootState }) => {
  var params = {}
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/users/message/message_list')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 消息详情
export const getMessageDetail = ({ commit, state, rootState }, message_id) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/users/message/message_detail')
    .send({
      message_id: message_id,
      user_id: rootState.userInfo.user_id
    })
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 清空消息
export const removeAllMessage = ({ commit, state, rootState }, message_id) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/users/message/message_delete')
    .send({
      user_id: rootState.userInfo.user_id
    })
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

export const appleNewLine = ({ commit, state, rootState }, params) => {
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/suggest/apply_line')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}
// 获取站点描述（实景图） line_id, site_id
export const getSiteInfo = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/api/get_site')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 获取附近上车站点
export const getNearSites = ({ commit, state, rootState }, params) => {
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  if (rootState.config.home_page_nav_id) {
    params.enterprise_nav_id = rootState.config.home_page_nav_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post(baseUrl + '/index.php/line/enterprise/get_near_sites')
    .send(params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        throw err
      } else {
        res = JSON.parse(res.text)
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function (res) {
            resolve(res)
          },
          failCallback: function (res) {
            reject(res)
          }
        })
      }
    })
  })
}

// 获取反馈详情
export const getFeedbackDetail = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/users/suggest/detail')
      .send({
        user_id: params.user_id || '',
        suggest_id: params.suggest_id || '',
        suggest_pid: params.suggest_pid || ''
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取企业供应商
export const getMotors = ({ commit, state, rootState }, enterprise_id) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/enterprise/get_motors')
      .send({
        enterprise_id: enterprise_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取评价详情
export const getEvaluateDetail = ({ commit, state, rootState }, evaluate_id) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/info/evaluate_detail')
      .send({
        evaluate_id: evaluate_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 评价反馈评分
export const evaluatePoint = ({ commit, state, rootState }, param) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/users/suggest/evaluate')
      .send({
        suggest_id: param.id,
        level: param.level
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

/**
 *  添加购票功能
 * */
// 获取我的订单导航
export const getOrderNav = ({ commit, state, rootState }, params) => {
  var _params = {}
  if (rootState.config.enterprise_id) {
    _params.enterprise_id = rootState.config.enterprise_id
  }
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/enterprise/get_order_navs')
      .send(_params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取我的订单列表
export const getOrderList = ({ commit, state, rootState }, params) => {
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  // （-1:全部，0:待支付，1:已支付，6:已取消）
  params.pay_status = -1
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/enterprise/get_order_list')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取我的订单详情
export const getOrderDetail = ({ commit, state, rootState }, order_num) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/order_detail_new')
      .send({
        order_num: order_num
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}
// 取消订单
export const cancelOrder = ({ commit, state, rootState }, params) => {
  params.user_id = rootState.userInfo.user_id
  params.line_type = 8
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/cancel_commuter_order')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 验票接口
export const checkTicket = ({ commit, state, rootState }, params) => {
  params.user_id = rootState.userInfo.user_id
  if (rootState.address.current_pos) {
    params.lng = rootState.address.current_pos.lng
    params.lat = rootState.address.current_pos.lat
  }
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/card/verify/commuter_ticket_check')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取线路验票二维码
export const getLineQrCode = ({ commit, state, rootState }, params) => {
  // params.user_id = rootState.userInfo.user_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/card/verify/get_qr_code')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 判读能否进入该企业
export const canEnterEnterprise = ({ commit, state, rootState }, enterprise_id) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/enterprise/can_enter_enterprise')
      .send({
        enterprise_id: enterprise_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 用于二维码 轮训查询
export const getCheckResult = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/card/verify/get_check_info')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取班次价格 票卡&单次票 缩略信息
export const getBusPriceDesc = ({ commit, state, rootState }, line_id) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/line/get_commuter_ticket_info')
      .send({
        line_id: line_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取班次 单次票 详细信息
export const getBusTicketInfo = ({ commit, state, rootState }, line_id) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/line/get_ticket_info')
      .send({
        line_id: line_id,
        user_id: rootState.userInfo.user_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取班次 票卡 详细信息
export const getBusCardInfo = ({ commit, state, rootState }, line_id) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/info/get_line_card')
      .send({
        line_id: line_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 预创建票卡card订单
export const payCard = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/commuter/buy')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 预创建单次票ticket订单
export const payTicket = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/buy')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 判断是否可以提交申请加班车 type = 2, 提交申请加班车 type = 1
export const canApplyMoreBus = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/info/apply_bus')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取未支付订单
export const checkHasUnpayTicket = ({ commit, state, rootState }, params) => {
  params = params || {}
  params.user_id = rootState.userInfo.user_id
  params.enterprise_id = rootState.config.enterprise_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/check_no_pay_order')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取联系方式
export const getBusContactPhone = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/line/get_contact_phone')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取退票日历和退票渠道
export const getRefundCalendar = ({ commit, state, rootState }, order_num) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/get_cancel_calendar')
      .send({
        user_id: rootState.userInfo.user_id,
        order_num: order_num
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 退票
export const refundTickets = ({ commit, state, rootState }, params) => {
  params.user_id = rootState.userInfo.user_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/refund_new')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 当前订单是否可验
// params: order_num
export const ifOrderCanCheck = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/order/ticket/can_order_check')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取可用车票
export const getUsefulTicket = ({ commit, state, rootState }, params) => {
  params = params || {}
  if (rootState.config && rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id
  }
  if (rootState.address.current_pos) {
    params.lng = rootState.address.current_pos.lng
    params.lat = rootState.address.current_pos.lat
  }
  // 默认 0:全部,1:次票,2:次卡,3:月卡
  params.order_type = 0
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/line/enterprise/get_available_orders')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 验票记录
export const getCheckedRecord = ({ commit, state, rootState }, params) => {
  // params.user_id = rootState.userInfo.user_id
  params.enterprise_id = rootState.config.enterprise_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/users/order/get_check_records')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取搜索地址提示
export const getCheckAddressList = ({ commit, state, rootState }, params) => {
  params.enterprise_id = rootState.config.enterprise_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/huawei/line/search_location')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          reject({
            result: '0000',
            info: '当前网络不可用，请稍后重试～'
          })
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 新版搜索线路编号
export const searchLineCode = ({commit, state, rootState}, params) => {
  if (rootState.address.current_city || rootState.address.location_city) {
    params.city_name = rootState.address.current_city || rootState.address.location_city
  }
  params.enterprise_id = rootState.config.enterprise_id
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/huawei/line/search_line_by_code')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          reject({
            result: '0000',
            info: '当前网络不可用，请稍后重试～'
          })
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 新版搜索线路地址
export const searchLineAddress = ({commit, state, rootState}, params) => {
  params.enterprise_id = rootState.config.enterprise_id || ''
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/huawei/line/search_line_by_location')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          reject({
            result: '0000',
            info: '当前网络不可用，请稍后重试～'
          })
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
              commit('UPDATE_IS_TRIGGER_SEARCH', false)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 新版收藏线路
export const searchCollectLines = ({commit, state, rootState}, params) => {
  params.enterprise_id = rootState.config.enterprise_id || ''
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/huawei/line/my_collect_lines')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          reject({
            result: '0000',
            info: '当前网络不可用，请稍后重试～'
          })
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 新版开放线路
export const getOpenLines = ({commit, state, rootState}, params) => {
  params.enterprise_id = rootState.config.enterprise_id || ''
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/huawei/line/unopen_lines')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          reject({
            result: '0000',
            info: '当前网络不可用，请稍后重试～'
          })
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 更新用户行为
export const updateTrackLog = ({commit, state, rootState}, params) => {
  params.enterprise_id = rootState.config.enterprise_id || ''
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/huawei/line/track_log')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 百度统计
export const postAnalyzeData = ({ commit, state, rootState }, params) => {
  var _params = params || {}
  if (!_params.opt_label) {
    _params.opt_value = rootState.userInfo.user_id || ''
    if (rootState.userInfo.user_id) {
      _params.opt_label = '登录'
    } else {
      _params.opt_label = '未登录'
    }
  }
  if (_params.type === 'pv') {
    postBaiduData(_params.category, _params.action, _params.opt_label, _params.opt_value || '')
  } else {
    postBaiduData(_params.category, _params.action, _params.opt_label, _params.opt_value || '')
  }
}

// 获取反馈类型
export const getFeedbackType = ({ commit, state, rootState }, params) => {
  var _id = params && params.id
  var _params = params || {}
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/users/suggest/get_suggest_type_list')
      .send({
        enterprise_id: rootState.config.enterprise_id || _params.enterprise_id || '',
        suggest_id: _id || ''
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}

// 获取最新的反馈内容
export const getLastFeedbackMessage = ({ commit, state, rootState }, params) => {
  var _id = params && params.id
  var _params = params || {}
  return new Promise(function (resolve, reject) {
    superagent
      .post(baseUrl + '/index.php/users/message/get_last_suggest_reply_message')
      .send({
        enterprise_id: rootState.config.enterprise_id || _params.enterprise_id || '',
        suggest_id: _id || ''
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js